import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'Capitalize'})
export class CapitalizePipe implements PipeTransform {
    public transform(text: string): string {
        return (text.at(0)?.toUpperCase() + text.slice(1)).replace('-', ' ');
    }
}
